module.exports = __webpack_public_path__ + "static/img/cross-with-outline.0eaccdb1.svg";